import React,{useState} from 'react';
import thumbnail from "../../assets/Images/video.jpg";
import YouTube from 'react-youtube';

import { FaPlay } from "react-icons/fa";

const VideoPlayer = () => {
    const [showVideo, setShowVideo] = useState(false);
    const onReady = (event) => {
        event.target.pauseVideo();
    };
    const toggleVideo = (e) => {
        e.stopPropagation(); 
        setShowVideo(!showVideo);
    };
    const opts = {
        height: '250',
        width: '100%',
        playerVars: {
            autoplay: 1,
        },
    };

    return (
        <div>
            {!showVideo ? (
                <div className="thumbnail-container">
                    <img
                        src={thumbnail}
                        alt="Thumbnail"
                        className='thumbnail-img'
                    />
                    <button onClick={toggleVideo} className="play-button">
                        <FaPlay />
                    </button>
                </div>
            ) : (
                <YouTube videoId="5liHQx2qzoE" opts={opts} onReady={onReady} />
            )}
        </div>
    );
};

export default VideoPlayer;


